angular.module('nv.SchoolMetricsModule').component('masterProgram', {
  template: require('./views/master-table.html'),
  bindings: {
    currentSchool: '<',
  },
  controller: 'MasterProgramCtrl',
});
